import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { VersionableId } from '../../../../types/versionableId';

type Props = {
  readonly isOpen: boolean;
  readonly smscId?: VersionableId;
  readonly onConfirmClick: () => void;
  readonly onCancelClick: () => void;
};

const SmscDeleteDialog = (props: Props) => {
  const {
    isOpen,
    smscId,
    onConfirmClick,
    onCancelClick,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onCancelClick}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        Delete SMSC
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          Are you sure you want to delete SMSC with <strong>{smscId?.resourceName}</strong> id?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelClick} color='inherit'>Cancel</Button>
        <Button onClick={onConfirmClick} startIcon={<DeleteForeverIcon />} color='primary'>
          Delete SMSC
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SmscDeleteDialog;
